import { DefaultState } from 'store/types';
import { AddByManagerParams } from 'store/reducers/lodgingRequest/addByManager/types';

export const EDIT_LODGING_REQUEST_DATA_REQUEST = 'EDIT_LODGING_REQUEST_DATA_REQUEST';
export const EDIT_LODGING_REQUEST_DATA_SUCCESS = 'EDIT_LODGING_REQUEST_DATA_SUCCESS';
export const EDIT_LODGING_REQUEST_DATA_FAILURE = 'EDIT_LODGING_REQUEST_DATA_FAILURE';

export interface EditLodgingRequestParams extends AddByManagerParams {
  id: string;
};

export interface EditLodgingRequestData {
  
};

export type EditLodgingRequestState = DefaultState & {
  contents?: EditLodgingRequestData;
};

interface ReadEditLodgingRequestDataRequest {
  type: typeof EDIT_LODGING_REQUEST_DATA_REQUEST;
};

interface ReadEditLodgingRequestDataSuccess {
  type: typeof EDIT_LODGING_REQUEST_DATA_SUCCESS,
  contents: EditLodgingRequestData;
}

interface ReadEditLodgingRequestDataFailure {
  type: typeof EDIT_LODGING_REQUEST_DATA_FAILURE;
}

export type EditLodgingRequestActionTypes = ReadEditLodgingRequestDataRequest | ReadEditLodgingRequestDataSuccess | ReadEditLodgingRequestDataFailure;